var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var AsyncStorage = require('./wrappers/AsyncStorage-wrapper');

const TABLE_NAME_PREFIX = "@RNDB@";
const TABLE_NAME_PREFIX_LENGTH = TABLE_NAME_PREFIX.length;

const TABLE_NAME_PRIMARY_VALUE_SEPARATOR = ":";
const TABLE_NAME_PRIMARY_VALUE_SEPARATOR_LENGTH = TABLE_NAME_PRIMARY_VALUE_SEPARATOR.length;

const TABLE_INFO_NAME = "@RNDBINFO@";

Array.prototype.inArray = function(comparer) {
    for(var i=0; i < this.length; i++) {
        if(comparer(this[i])) return true;
    }
    return false;
};

Array.prototype.pushIfNotExist = function(element, comparer) {
    if (!this.inArray(comparer)) {
        this.push(element);
    }
};

class DBManager
{
  _tableInfo = {};
  _tables = {};
  constructor()
  {

  }

  //
  // tableInfoEntriesArray is of the form:
  //
  // [
  //   {tableName:"MyTableName1", primaryKey:"MyTable1sPrimaryKey"},
  //   {tableName:"MyTableName2", primaryKey:"MyTable2sPrimaryKey"}
  // ]
  //
  initialize(tableInfoEntriesArray, completion)
  {
    var self = this;
    DBManager.loadTableInfo(function(tableInfo)
    {
      self._tableInfo = tableInfo;
      self.addTables(tableInfoEntriesArray, function()
      {
        DBManager.loadTableRowsForTableInfo(self._tableInfo, function(tableNameRowKeys)
        {
          for( var tableName in tableNameRowKeys )
          {
            self._tables[tableName].setRowKeys(tableNameRowKeys[tableName]);
          }

          completion();
        })
      })
    })
  }

  table(tableName)
  {
    if( (typeof tableName === 'undefined') || // can't retrieve table without name
        (typeof this._tables[tableName] === 'undefined') ) // can't retrieve table if it isn't added
    {
      return null;
    }

    return this._tables[tableName];
  }

  addTable(tableInfoEntry, completion)
  {
    var primaryKey = tableInfoEntry.primaryKey;
    var tableName = tableInfoEntry.tableName;
    if( typeof this._tableInfo[tableName] === 'undefined' ||
        this._tableInfo[tableName].primaryKey != primaryKey ||
        typeof this._tables[tableName] === 'undefined' )
    {
      this._tables[tableName] = new Table(tableName, primaryKey);
      this._tableInfo[tableName] = this._tables[tableName].getTableInfoEntry();

      var self = this;
      DBManager.saveTableInfo(this._tableInfo,function()
      {
        completion(self._tables[tableName]);
      })
      return;
    }
    else
    {
      completion(this._tables[tableName]);
    }
  }

  // recursively add tables, don't pass in index
  addTables(tableInfoEntriesArray, completion, index)
  {
    if( typeof index === 'undefined' ) index = 0;

    if( index >= tableInfoEntriesArray.length )
    {
      completion();
      return;
    }

    var self = this;
    this.addTable(tableInfoEntriesArray[index], function()
    {
      self.addTables(tableInfoEntriesArray, completion, index+1);
    })
  }

  clear(completion)
  {
    AsyncStorage.clear(completion);
  }
}

//
// separates the table name and primary key value and returns them
//
// if tableNamePrimaryValue is invalid, then it return false
//
DBManager.isValidTableEntryForDB = function(tableNamePrimaryValue, tableInfo)
{
  if( tableNamePrimaryValue.indexOf(TABLE_NAME_PREFIX) != 0 ) return false; // no table name prefix

  var indexOfSeparator = tableNamePrimaryValue.indexOf(TABLE_NAME_PRIMARY_VALUE_SEPARATOR);
  if( indexOfSeparator < (TABLE_NAME_PREFIX_LENGTH+1) ) return false; // no valid primary value

  var tableName = tableNamePrimaryValue.substring(TABLE_NAME_PREFIX_LENGTH, indexOfSeparator);
  if( typeof tableInfo[tableName] === 'undefined' ) return false; // table does not exist in table info

  var primaryValue = tableNamePrimaryValue.substring(indexOfSeparator+TABLE_NAME_PRIMARY_VALUE_SEPARATOR_LENGTH, tableNamePrimaryValue.length);

  return {tableName:tableName, primaryValue:primaryValue};
}

//
// retrieves the table info
//
DBManager.loadTableInfo = function(completion)
{
  AsyncStorage.getItem(TABLE_INFO_NAME, function(error, tableInfoResult)
  {
    if( tableInfoResult == null || error != null )
    {
      // table info doesn't exist yet, lets make it
      AsyncStorage.setItem(TABLE_INFO_NAME, JSON.stringify({}), function()
      {
        completion({})
      })
    }
    else
    {
      var tableInfo = tableInfoResult;
      try
      {
        var tableInfoParsed = JSON.parse(tableInfo);
        completion(tableInfoParsed);
      }
      catch(e)
      {
        console.log("ERROR!!! Cannot parse table info", tableInfoResult, e);

        // table info isn't valid, lets remake it
        AsyncStorage.setItem(TABLE_INFO_NAME, JSON.stringify({}), function()
        {
          completion({})
        })
      }
    }
  })
}

DBManager.saveTableInfo = function(tableInfo, completion)
{
  var tableInfoStr = JSON.stringify(tableInfo);
  AsyncStorage.setItem(TABLE_INFO_NAME, tableInfoStr, completion);
}

DBManager.loadTableRowsForTableInfo = function(tableInfo, completion)
{
  var tableNameRowKeys = {};
  for( var tableName in tableInfo ) tableNameRowKeys[tableName] = [];

  AsyncStorage.getAllKeys(function(error, keys)
  {
    if( error == null )
    {
      for( var i = 0; i < keys.length; i++ )
      {
        var key = keys[i];
        var tableNamePrimaryValue = DBManager.isValidTableEntryForDB(key, tableInfo);
        if( tableNamePrimaryValue === false ) continue;

        tableNameRowKeys[tableNamePrimaryValue.tableName].push(key);
      }
    }

    completion(tableNameRowKeys);
  })
}

class Table
{
  _tableName = null;
  _primaryKey = null;
  _rowKeys = [];
  constructor(tableName, primaryKey, allPrimaryKeyValues)
  {
    this._tableName = tableName;
    this._primaryKey = primaryKey;
  }

  setRowKeys(rowKeys)
  {
    // alert(JSON.stringify(rowKeys));
    this._rowKeys = rowKeys;
  }

  //
  // will overwrite an existing row
  //
  set(row, completion)
  {
    if( typeof row[this._primaryKey]  === 'undefined' )
    {
      row[this._primaryKey] = Math.round(Math.random()*10000);
    }

    if( typeof row.id  === 'undefined' )
    {
      row.id = Math.round(Math.random()*10000);
    }

    try
    {
      var rowString = JSON.stringify(row);
      var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);

      // alert(fullKey + " " + rowString)
      var self = this;
      AsyncStorage.setItem(fullKey, rowString, function(result)
      {
        self._rowKeys.push(fullKey);
        if( completion ) completion(result == null || typeof result === 'undefined')
      })
      return;
    }
    catch (e)
    {
      console.log("Error!!! Could not parse row.", row, e)
      if( completion ) completion(false);
    }
  }

  //
  // multiple row set, do not pass in index
  //
  setRows(rows, completion, index)
  {
    if( typeof index === 'undefined' ) index = 0;
    if( index >= rows.length )
    {
      completion();
      return;
    }

    // check if there are different keys
    var shouldClear = (rows.length != this._rowKeys.length) && (this._rowKeys.length > 0);
    if( !shouldClear && (this._rowKeys.length > 0) && (rows.length == this._rowKeys.length) )
    {
      for( var i = 0; i < rows.length; i++ )
      {
        var rowKey = rows[i][this._primaryKey];
        var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, rowKey);
        var foundKey = false;
        for( var j = 0; j < this._rowKeys.length; j++ )
        {
          if( this._rowKeys[j] == fullKey )
          {
            foundKey = true;
            break;
          }
        }
        if( !foundKey )
        {
          shouldClear = true;
          break;
        }
      }
    }

    if( shouldClear )
    {
      var self = this;
      this.removeAll(()=>
      {
        self.setRows(rows, completion, index);
      })
      return;
    }

    var keyValuePairs = [];
    for( var i = 0; i < rows.length; i++ )
    {
      var row = rows[i];
      if( typeof row[this._primaryKey]  === 'undefined' )
      {
        row[this._primaryKey] = Math.round(Math.random()*10000);
      }

      if( typeof row.id  === 'undefined' )
      {
        row.id = Math.round(Math.random()*10000);
      }

      var rowString = JSON.stringify(row);
      var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);
      keyValuePairs.push([fullKey, rowString]);
      this._rowKeys.pushIfNotExist(fullKey, function(e) {
        return e == fullKey;
      });
    }

    try
    {
      var self = this;
      AsyncStorage.multiMerge(keyValuePairs, function(result)
      {
        if( completion ) completion(result == null || typeof result === 'undefined')
      })
      return;
    }
    catch (e)
    {
      console.log("Error!!! Could not parse row.", row, e)
      if( completion ) completion(false);
    }


    this.update(rows[index], function()
    {
      self.setRows(rows, completion, index+1);
    })
  }

  //
  // updates a row if it exists, or adds it if not
  //
  update(row, completion)
  {
    if( typeof row[this._primaryKey]  === 'undefined' )
    {
      row[this._primaryKey] = Math.round(Math.random()*10000);
    }

    if( typeof row.id  === 'undefined' )
    {
      row.id = Math.round(Math.random()*10000);
    }

    try
    {
      var rowString = JSON.stringify(row);
      var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);
      this._rowKeys.pushIfNotExist(fullKey, function(e) {
            return e == fullKey;
        });
      AsyncStorage.mergeItem(fullKey, rowString, function(error)
      {
        completion(error == null || typeof error === 'undefined')
      })
      return;
    }
    catch (e)
    {
      console.log("Error!!! Could not parse row.", row, e)
      completion(false);
    }
  }

  get(primaryValue, completion)
  {
    var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, primaryValue);

    AsyncStorage.getItem(fullKey, function(error, result)
    {
      var parsedObj = null;
      try {
        parsedObj = JSON.parse(result);
      } catch (e) {

      } finally {

      }
      completion(parsedObj);
    })
  }

  getAll(completion)
  {
    AsyncStorage.multiGet(this._rowKeys, (error, stores) =>
    {
      var rows = [];
      stores.map((result, i, store) => {
       // get at each store's key/value so you can work with it
       let key = store[i][0];
       try {
         let value = JSON.parse(store[i][1]);
         rows.push(value);
       } catch (e) {
         console.log("Error!!!!! getAll parse error", store, key,  e)
       } finally {}
      });
      completion(rows);
    })
  }

  remove(primaryValue, completion)
  {
    var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, primaryValue);

    var self = this;
    AsyncStorage.removeItem(fullKey, (error) =>
    {
      for( var i = 0; i < self._rowKeys; i++ )
      {
        if( self._rowKeys[i] == primaryValue )
        {
          self._rowKeys.splice(i, 1);
          break;
        }
      }
      if( completion) completion();
    })
  }

  removeAll(completion)
  {
    var self = this;
      self._rowKeys = [];
    AsyncStorage.multiRemove(this._rowKeys, (error) =>
    {
      if( completion) completion();
    })
  }

  getTableInfoEntry()
  {
    return {tableName:this._tableName, primaryKey:this._primaryKey};
  }
}

Table.fullKeyForTableNamePrimaryValue = function(tableName, primaryValue)
{
  return TABLE_NAME_PREFIX + tableName + TABLE_NAME_PRIMARY_VALUE_SEPARATOR + primaryValue;
}

module.exports = DBManager;
